const C = {
  name: "GhanaianCedi",
  dimensions: { width: 40, height: 40 },
  content: `
    <g>
      <path fill="currentColor" stroke="none" d="M20 0C8.97 0 0 8.97 0 20C0 31.03 8.97 40 20 40C31.03 40 40 31.03 40 20C40 8.97 31.03 0 20 0ZM20 38C10.07 38 2 29.92 2 20C2 10.07 10.07 2 20 2C29.92 2 38 10.07 38 20C38 29.92 29.92 38 20 38Z"/>
      <path fill="currentColor" stroke="none" d="M23.53 16.46C23.92 16.85 24.55 16.85 24.94 16.47C25.33 16.08 25.33 15.45 24.95 15.06C23.87 13.97 22.5 13.29 21 13.08V11C21 10.45 20.55 10 20 10C19.45 10 19 10.45 19 11V13.08C15.61 13.57 13 16.48 13 20C13 23.52 15.61 26.43 19 26.92V29C19 29.55 19.45 30 20 30C20.55 30 21 29.55 21 29V26.92C22.5 26.71 23.87 26.03 24.95 24.94C25.34 24.55 25.34 23.91 24.94 23.53C24.54 23.15 23.91 23.14 23.53 23.54C22.83 24.24 21.96 24.71 21 24.9V15.1C21.96 15.29 22.83 15.76 23.53 16.46ZM15 20C15 17.59 16.72 15.57 19 15.1V24.9C16.72 24.43 15 22.41 15 20Z"/>
    </g>
  `
};
export {
  C as GhanaianCedi
};
